import { render, staticRenderFns } from "./PickUpEditor.vue?vue&type=template&id=cf3fa882"
import script from "./PickUpEditor.vue?vue&type=script&lang=js"
export * from "./PickUpEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports